module.exports = __webpack_public_path__ + "static/profile-63e477b4e3603dcc06bc504039b7dc1d.png";